// This allows you to import Checkbox as a default or named export
export { default, default as Checkbox } from './checkbox';
export type { CheckboxProps } from './types';
